import { alpha, styled } from '@mui/material/styles';
import { MdSource } from 'react-icons/md';

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90vw',
  height: '25vh',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
});

export const RootStyled = styled('div')(() => ({
  padding: '32px 24px',
  minHeight: 550,
  '@media(max-width: 750px)': {
    display: 'none',
  },
}));

export const ContainerFolderNameStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  '& h3': {
    marginBottom: 32,
  },
  '& .enable': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.1),
    padding: 3,
    borderRadius: 5,
    cursor: 'pointer',
  },
  '& .folderName': {
    color: theme.palette.global.lightgray,
  },
}));

export const DefaultPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 100,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 50,
  },
}));

export const IconStyled = styled(MdSource)(({ theme }) => ({
  color: alpha(theme.palette.global.lightgray, 0.5),
  fontSize: 200,
}));

export const MobileRootStyled = styled('div')(({ theme }) => ({
  paddingBottom: 24,
  width: '100vw',
  '& .folderList': {
    margin: 24,
    padding: '18px 0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 64,
    '& svg': {
      color: theme.palette.global.lightgray,
      fontSize: 30,
    },
    '& .folders': {
      borderTop: '1px solid #ccc',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      '& p': {
        maxWidth: 250,
        color: theme.palette.secondary.main,
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& p + p': {
        fontSize: 12,
        color: theme.palette.global.lightgray,
      },
      '&:last-child': {
        borderBottom: '1px solid #ccc',
        paddingBottom: 10,
      },
    },
  },
  '& .documents': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    borderTop: '1px solid #ccc',
    paddingRight: 4,
    paddingTop: 10,
    '& + .documents': {
      marginTop: 4,
    },
    '& p': {
      maxWidth: 250,
      color: theme.palette.secondary.main,
      fontSize: 13,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& p + p': {
      fontSize: 12,
      color: theme.palette.global.lightgray,
    },
    '&:last-child': {
      borderBottom: '1px solid #ccc',
      paddingBottom: 10,
    },
    '& .downloadIcon': {
      fontSize: 22,
      color: theme.palette.secondary.main,
    },
  },
  '@media(min-width: 751px)': {
    display: 'none',
  },
}));

export const DivNoDataStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  marginLeft: '5%',
  height: '50vh',
});
